import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    StudyTeamMemberProps,
    LoadStudyTeamMemberById,
    setStudyTeamMemberEdit,
    setStudyTeamMemberReloadEdit,
    initStudyTeamMember,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    teamMemberId = null,
}: StudyTeamMemberProps) => {
    const study = useSelector((state: StoreType) => state.study.studyView)
    const teamMember = useSelector((state: StoreType) => state.studyTeamMember.teamMemberEdit)
    const reloadEdit = useSelector((state: StoreType) => state.studyTeamMember.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setStudyTeamMemberReloadEdit(false))
        setTimeout(() => {
            dispatch(setStudyTeamMemberReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (teamMemberId === 0) {
            dispatch(setStudyTeamMemberEdit(initStudyTeamMember))
            reload()
        } else {
            setLoadState(PENDING)
            LoadStudyTeamMemberById(teamMemberId, study.id).then((res) => {
                dispatch(setStudyTeamMemberEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!teamMember) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{teamMember.id ? `${lang.editTeamMember} # ${teamMember.id}` : lang.addTeamMember}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form teamMember={teamMember} />
                }
                {
                    reloadEdit
                    && <Form teamMember={teamMember} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
